<app-header-four></app-header-four>

<section class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Obras y Proyectos Sociales</h2>
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li>Obras y Proyectos</li>
            </ul>
        </div>
    </div>
</section>

<section class="symptoms-area pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="symptoms-image">
                    <img src="assets/img/symptoms-img.png" alt="proyectos">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="symptoms-content">
                    <span class="sub-title">Compromiso Social</span>
                    <h2>Desarrollo Comunitario</h2>
                    <p>
                        La Fundación Acosta Ñu desarrolla obras sociales en distintos departamentos del Paraguay, 
                        enfocadas en mejorar la calidad de vida de las comunidades mediante soluciones concretas 
                        como acceso a agua potable y fortalecimiento del entorno social.
                    </p>

                    <ul>
                        <li><span><i class='flaticon-tick'></i> Construcción de pozos artesianos</span></li>
                        <li><span><i class='flaticon-tick'></i> Sistemas de agua potable (aguaterías)</span></li>
                        <li><span><i class='flaticon-tick'></i> Proyectos en comunidades rurales</span></li>
                        <li><span><i class='flaticon-tick'></i> Apoyo a familias en situación vulnerable</span></li>
                        <li><span><i class='flaticon-tick'></i> Desarrollo sostenible comunitario</span></li>
                        <li><span><i class='flaticon-tick'></i> Cooperación con instituciones</span></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="doctors-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Proyectos</span>
            <h2>Obras Realizadas</h2>
        </div>

        <div class="row">

            <!-- PROYECTO 1 -->
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-doctors-box">
                    <div class="image">
                        <img src="assets/img/doctors/img11.jpg" alt="pozo artesiano">
                    </div>
                    <div class="content">
                        <h3>SISTEMA DE AGUA POTABLE ASENTAMIENTO VIRGEN DEL CARMEN</h3>
                            <span>LOCALIDAD: ASENTAMIENTO VIRGEN DEL CARMEN</span>
                        <span>DISTRITO: LORETO</span>
                        <span>DEPARTAMENTO: CONCEPCION</span>

                        <span>BENEFICIARIOS: 120 familias</span>
                    </div>
                </div>
            </div>

            <!-- PROYECTO 2 -->
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-doctors-box">
                    <div class="image">
                        <img src="assets/img/doctors/img12.jpg" alt="aguateria">
                    </div>
                     <div class="content">
                        <h3>SISTEMA DE AGUA POTABLE ASENTAMIENTO PRIMAVERA</h3>
                            <span>LOCALIDAD: ASENTAMIENTO PRIMAVERA</span>
                        <span>DISTRITO: CAPIIBARY</span>
                        <span>DEPARTAMENTO: SAN PEDRO</span>

                        <span>BENEFICIARIOS: 120 familias</span>
                    </div>
                </div>
            </div>

            <!-- PROYECTO 3 -->
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-doctors-box">
                    <div class="image">
                        <img src="assets/img/doctors/img13.jpg" alt="comunidad">
                    </div>
                     <div class="content">
                        <h3>SISTEMA DE AGUA POTABLE ASENTAMIENTO TAPIRACUAY POTY</h3>
                            <span>LOCALIDAD: ASENTAMIENTO TAPIRACUAY POTY</span>
                        <span>DISTRITO: CAPIIBARY</span>
                        <span>DEPARTAMENTO: SAN PEDRO</span>

                        <span>BENEFICIARIOS: 120 familias</span>
                    </div>
                </div>
            </div>

            <!-- PROYECTO 4 -->
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-doctors-box">
                    <div class="image">
                        <img src="assets/img/doctors/img14.jpg" alt="infraestructura">
                    </div>
                    <div class="content">
                        <h3>SISTEMA DE AGUA POTABLE ASENTAMIENTO AMISTAD</h3>
                            <span>LOCALIDAD: ASENTAMIENTO AMISTAD</span>
                        <span>DISTRITO: CHORE</span>
                        <span>DEPARTAMENTO: SAN PEDRO</span>

                        <span>BENEFICIARIOS: 120 familias</span>
                    </div>
                </div>
            </div>

            <!-- PROYECTO 5 -->
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-doctors-box">
                    <div class="image">
                        <img src="assets/img/doctors/img15.jpg" alt="familias">
                    </div>
                    <div class="content">
                        <h3>SISTEMA DE AGUA POTABLE ASENTAMIENTO CHOREMI</h3>
                            <span>LOCALIDAD: ASENTAMIENTO CHOREMI</span>
                        <span>DISTRITO: CHORE</span>
                        <span>DEPARTAMENTO: SAN PEDRO</span>

                        <span>BENEFICIARIOS: 120 familias</span>
                    </div>
                </div>
            </div>

            <!-- PROYECTO 6 -->
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-doctors-box">
                    <div class="image">
                        <img src="assets/img/educacion.jpeg" alt="educacion">
                    </div>
                    <div class="content">
                        <h3>Programa Educativo – Central</h3>
                        <span>Capacitación y formación</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>